import { FC, useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { centerComponentInMiddleofView } from '@/utilities';

interface WorkspaceResourceLoadingProps {
    resourceType?: string;
}

const WorkspaceResourceLoading: FC<WorkspaceResourceLoadingProps> = ({ resourceType }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <div style={{ ...centerComponentInMiddleofView, height: '100%', color: token.colorTextTertiary }}>
            <span style={{ display: 'inline-block' }}>
                <LoadingOutlined spin style={{ marginRight: '0.75rem' }} />
                Loading {resourceType ?? 'Resource'}...
            </span>
        </div>
    );
};

export default WorkspaceResourceLoading;
